<!--
하우스 > 일괄작업
 - 컨트롤러를 따로 사용하지 않고, 컨트롤러의 기능을 mixin 상속받음
------------------------------------
-->
<template>
    <div
        class="bg-white"
        :uk-sticky="stickyLayout"
    >
        <!-- 전체작업 -->
        <div v-show="! itemChecked" class="p-0d5rem bg-white border border-white">
            <div class="uk-flex uk-flex-between uk-flex-bottom">
                <!-- 선택된 아이템 없음 -->
                <div class="no-selected-msg">
                    {{ batch.item_checked_nothing_msg }}
                </div>

                <div class="uk-width-expand"></div>



                <!-- 포맷 -->
                <app-input-select v-if="activeExcelDown" v-model="excelFormat" :options="excelFormatOptions"></app-input-select>

                <!-- 전체  -->
                <button
                    class="uk-button uk-button-white"
                    type="button"

                    v-if="activeExcelDown"

                    @click="searchedExcel()"
                >
                    <i class="material-icons">list</i>
                    검색결과 엑셀 다운로드
                </button>
            </div>

        </div>

        <!-- 선택작업 -->
        <div v-show="itemChecked" class="p-0d5rem bg-sky-50 border border-sky-600">
            <div class="uk-flex uk-flex-between uk-flex-middle">
                <!-- 선택개수안내 -->
                <div class="uk-position-relative w-30rem h-2rem">
                    <div class="selected-msg uk-position-absolute " v-html="itemCheckedInfo"></div>
                </div>

                <button
                    v-if="onlyGeneralOrUser"
                    class="uk-button uk-button-small uk-button-white mr-1rem"
                    type="button"
                    :disabled="disabled"
                    v-on:click="$refs['shipout-req'].jobInit()"
                    title="출고보류중인 상품을 출고요청합니다"
                >
                    <i class="material-icons">exit_to_app</i>
                    출고요청
                </button>

                <div class="uk-width-expand"></div>



                <!-- 포맷 -->
                <app-input-select v-if="activeExcelDown" v-model="excelFormat" :options="excelFormatOptions"></app-input-select>

                <!-- 선택 BL PDF 다운 (TASK-147) -->
                <button
                    class="uk-button uk-button-white mr-1rem"
                    type="button"
                    :checked-disabled="checkedDisabled"

                    v-if="pdfBlAvailable"

                    @click="selectedPdf(bl)"
                >
                    <i class="material-icons">picture_as_pdf</i>
                    선택항목 BL PDF
                </button>

                <!-- 선택 INVOICE PDF 다운 (TASK-147) -->
                <button
                    class="uk-button uk-button-white mr-1rem"
                    type="button"
                    :checked-disabled="checkedDisabled"

                    v-if="pdfInvoiceAvailable"

                    @click="selectedPdf(commercialInvoice)"
                >
                    <i class="material-icons">picture_as_pdf</i>
                    선택항목 INVOICE PDF
                </button>

                <!-- 선택 다운 -->
                <button
                    class="uk-button uk-button-white"
                    type="button"
                    :checked-disabled="checkedDisabled"

                    v-if="activeExcelDown"

                    @click="selectedExcel()"
                >
                    <i class="material-icons">check</i>
                    선택항목 엑셀 다운로드
                </button>
            </div>
        </div>


        <!-- 처리중화면 blockui -->
        <overlay-loading ref="down-overlay">
            <div slot="dialog">
                <loading-icon></loading-icon>
                다운로드중.. 잠시만 기다리세요.
            </div>
        </overlay-loading>

        <!-- 출고요청 기능 -->
        <shipout-req
            ref="shipout-req"
            :batch="batch"
            :csrfToken="csrfToken"
        ></shipout-req>

    </div>

</template>

<script>
import checkedCountable from '../../checked-countable';
import stickiable from '../../stickable';
import searchedSelectable from '../../searched-selectable';
import LoadingIcon from "../../../common/loading-icon.vue";
import OverlayLoading from "../../../common/overlay-loading.vue";

export default {
    mixins: [
        checkedCountable,
        stickiable,
        searchedSelectable,
    ],
    components: {
        LoadingIcon,
        OverlayLoading,
        'shipout-req': require('./shipout-req.vue').default,
    },
    props: {
        /**
         * 일괄기능 공유data (상세정의는 컨트롤러 참고)
         */
        batch: Object,

        // csrf-token
        csrfToken: String,

        // 지역ID
        regionId: Number,

        /**
         * 총괄관리자 여부
         */
        hasGeneral: {
            type: Boolean,
            default: false
        },

        /**
         * 총괄관리자 & 회원사인지 (창고제한)
         */
        onlyGeneralOrUser: {
            type: Boolean,
            default: false
        },

        /**
         * 엑셀포맷 옵션
         */
        excelFormatOptions: {
            type: Array,
            default: [],
        },

        /**
         * 일괄 PDF 다운로드 건수 상한 (TASK-147, 서버 HouseListPdfBuilder::BATCH_LIMIT 과 동일값)
         */
        pdfBatchLimit: {
            type: Number,
            default: 100,
        },
    },
    data: function () {
        // 엑셀포맷 첫번째 옵션 선택 (옵션이 없는 화면 = 총괄 전체 출고내역 /admin/houses · 회원사 전체지역 /region_members/{uid}/houses 은 null)
        //  - TASK-147 3-B (2026-09-20): 종전 `_.first(this.excelFormatOptions).val` 은 옵션이 빈 배열이면 예외 → data() 미반환 → commercialInvoice/bl 미정의로 일괄 PDF 버튼 TypeError (E2E S1/S2 실측)
        let first = _.first(this.excelFormatOptions);
        let selected = first ? first.val : null;

        return {
            /** (integer) 엑셀포맷 */
            excelFormat: selected,

            // TASK-147: 일괄 PDF 포맷 정보 (수출허가서 batch/jobs/export-permits/main.vue 와 동일 형식)
            commercialInvoice: {
                accept: 'pdf',
                format: 'commercial-invoice',
                name: 'INVOICE(소비세환급)',
            },
            bl: {
                accept: 'pdf',
                format: 'bl',
                name: 'BL(송장)',
            },
        };
    },
    computed: {
        // 작업 버튼 비활성화 여부
        disabled() {
            // 선택된 아이템없으면 비활성화
            return this.batch.checked_item_count === 0;
        },

        // 선택작업 버튼 비활성화 여부
        checkedDisabled() {
            // 선택된 아이템없으면 비활성화
            return this.batch.checked_item_count === 0;
        },

        // 스티키 레이아웃 적용여부
        stickyLayout() {
            return this.onSticky && this.itemChecked;
        },

        /**
         * 현재 페이지에 INVOICE 일괄 PDF 지원 하우스가 하나라도 있는지 (TASK-147)
         * - 페이지에 지원 하우스가 없으면 버튼 자체를 숨겨 미지원 센터 화면은 변화 없음
         * @return boolean
         */
        pdfInvoiceAvailable() {
            return _.some(this.batch.items, 'pdf_invoice');
        },

        /**
         * 현재 페이지에 BL 일괄 PDF 지원 하우스가 하나라도 있는지 (TASK-147)
         * @return boolean
         */
        pdfBlAvailable() {
            return _.some(this.batch.items, 'pdf_bl');
        },

        /**
         * 선택된 항목 중 INVOICE 일괄 PDF 지원 건수 (TASK-147)
         * @return int
         */
        checkedPdfInvoiceCount() {
            return _.filter(this.checkedItems, 'pdf_invoice').length;
        },

        /**
         * 선택된 항목 중 BL 일괄 PDF 지원 건수 (TASK-147)
         * @return int
         */
        checkedPdfBlCount() {
            return _.filter(this.checkedItems, 'pdf_bl').length;
        },

        /**
         * 선택된 엑셀포맷명
         * @returns {string|null}
         */
        excelFormatName() {
            if (! this.excelFormat) {
                return null;
            }

            let selected = _.find(this.excelFormatOptions, (opt) => {
                return opt.val == this.excelFormat;
            });
            if (selected) {
                return selected.text;
            }
            return null;
        },

        /**
         * 엑셀 다운로드기능 활성여부
         * @returns {boolean}
         */
        activeExcelDown() {
            return this.excelFormatOptions.length > 0;
        }

    },
    methods: {
        /**
         * 선택 다운실행
         */
        selectedExcel(info) {
            let confirm_msg = '선택한 내역을 [' + this.excelFormatName + '] 다운로드 하시겠습니까?' + '\n(총 ' + this.itemCheckedCount + '건)';

            let url = new URL(this.basedUrl);
            let searchParams = url.searchParams;
            searchParams.set("__accept", "excel");
            searchParams.set("excel_format", this.excelFormat);

            // post 파라메터 작성
            let post_params = new URLSearchParams();
            post_params.set("_token", this.csrfToken);
            let checked_ids = _.map(this.checkedItems, 'id');
            _.each(checked_ids, (id) => {
                post_params.append("id_in[]", id);
                //  searchParams.append("id_in[]", id);
            });
            //post_params = null;
            //console.log(url.toString()); return;
            //console.log(checked_ids); return;

            // fetch 옵션
            let fetch_options = {
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: post_params,
            };

            // 다운처리
            this.download(url, fetch_options, [
                confirm_msg,
                this.guardNoSelected,
            ]);
        },

        /**
         * 선택 일괄 PDF 다운실행 (TASK-147)
         * @param {Object} info { accept, format, name }
         */
        selectedPdf(info) {
            let label = (info.format === this.bl.format) ? 'BL' : 'INVOICE';
            let eligible_count = (info.format === this.bl.format) ? this.checkedPdfBlCount : this.checkedPdfInvoiceCount;
            let confirm_msg = '선택한 ' + this.itemCheckedCount + '건 중 지원 ' + eligible_count + '건을 ' + label + ' PDF 로 다운로드 하시겠습니까?';

            let url = new URL(this.basedUrl);
            let searchParams = url.searchParams;
            searchParams.set("__accept", info.accept);
            searchParams.set("format", info.format);

            // post 파라메터 작성
            let post_params = new URLSearchParams();
            post_params.set("_token", this.csrfToken);
            let checked_ids = _.map(this.checkedItems, 'id');
            _.each(checked_ids, (id) => {
                post_params.append("id_in[]", id);
            });

            // fetch 옵션
            let fetch_options = {
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: post_params,
            };

            // 다운처리 (선택없음 → 상한초과 → 지원0건 → 컨펌 순으로 가드 후 다운)
            this.download(url, fetch_options, [
                this.guardNoSelected,
                () => this.guardPdfBatchLimit(),
                () => this.guardPdfEligible(eligible_count),
                confirm_msg,
            ]);
        },

        /**
         * 일괄 PDF 건수 상한 검증 (TASK-147, D-1 — 서버 HouseListPdfBuilder::BATCH_LIMIT 과 동일값)
         * @return boolean
         */
        guardPdfBatchLimit() {
            if (this.itemCheckedCount > this.pdfBatchLimit) {
                alert('일괄 PDF 는 최대 ' + this.pdfBatchLimit + '건까지 선택할 수 있습니다.');
                return false;
            }
            return true;
        },

        /**
         * 선택 항목 중 PDF 지원 0건 검증 (TASK-147, D-2)
         * @param {int} eligible_count
         * @return boolean
         */
        guardPdfEligible(eligible_count) {
            if (eligible_count === 0) {
                alert('선택한 항목 중 PDF 를 지원하는 건이 없습니다.');
                return false;
            }
            return true;
        },

        /**
         * 검색결과 다운
         */
        searchedExcel(info) {
            let confirm_msg = '검색된 모든 내역을 [' + this.excelFormatName + '] 다운로드 하시겠습니까?' + '\n(총 ' + this.searchedCount + '건)';

            let url = new URL(this.searchedUrl);
            let searchParams = url.searchParams;
            searchParams.set("__accept", "excel");
            searchParams.set("excel_format", this.excelFormat);
            //console.log(url.toString());

            // fetch 옵션
            let fetch_options = {};

            // 다운처리
            this.download(url, fetch_options, [
                confirm_msg,
                this.guardSearchedDownLimit,
            ]);
        }
    }
}
</script>

<style lang="scss" scoped>

.no-selected-msg {
    color: #999;
}
</style>